// import 'whatwg-fetch';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from "apollo-link-error";
import { createUploadLink } from 'apollo-upload-client'

export default {
    install(Vue, options = {}) {
        if (options.graphqlUri) {
            Vue.$graphqlUri = options.graphqlUri;
        } else {
            Vue.$graphqlUri = process.env.GRAPHQL_URI || process.env.VUE_APP_GRAPHQL_URI;
            if (!Vue.$graphqlUri && window) {
                Vue.$graphqlUri = window.location.origin;
            }
        }
        const httpLinkConfig = {
            uri: `${Vue.$graphqlUri}/graphql/`,
            headers: options.headers || {},
        };

        if (options.isServer) {
            httpLinkConfig.fetch = require('node-fetch');
        }

        const cache = new InMemoryCache({
            addTypename: false,
        });

        const authMiddleware = new ApolloLink((operation, forward) => {
            let token = null;
            if (Vue.$store && Vue.$store.state && Vue.$store.state.Login) {
                token = Vue.$store.state.Login.authToken;
            } else if (Vue.graphqlJwt) {
                token = Vue.graphqlJwt;
            }
            if (token) {
                operation.setContext({
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                });
            }
            operation.setContext({
                uri: `${Vue.$graphqlUri}/graphql/`,
            });
            return forward(operation);
        });

        const errorLink = onError(({ graphQLErrors, operation, forward }) => {
            if (graphQLErrors) {
                graphQLErrors.map(({ extensions }) => {
                    if (extensions) {
                        if (extensions.code === 'ACCESS_TOKEN_EXPIRED') {
                            if (Vue.$store) {
                                Vue.$store.commit('Login/setAuthToken', null);
                                Vue.$store
                                    .dispatch('Login/refreshAuthToken')
                                    .then(() => {
                                        return forward(operation);
                                    })
                                    .catch(() => {});
                            } else {
                                return forward(operation);
                            }
                        }
                    }
                });
            }
        });

        const client = new ApolloClient({
            link: authMiddleware.concat(errorLink).concat(createUploadLink(httpLinkConfig)),
            cache,
            ...options,
        });
        Vue.prototype.$graphql = client;
        Vue.$graphql = client;
    },
};
